// An electronic waltz in 3/4, downtempo: it starts on a pickup (the melody's
// first note comes before bar 1), the kick falls on one and the hi-hats on
// two and three, the glockenspiel floats over a string pad, and the 808 bass
// holds each bar.
meter: 3/4
tempo: 96
pickup: beat 3
key: C major

lead: mallets.glockenspiel -> delay -> reverb
lead = | g5 | c6 _ e6 | d6 _ c6 | b5 _ a5 | g5 _ _ | a5 _ c6 | b5 _ d6 | c6 _ _ | - |
lead.delay.sync = 1.5
lead.delay.mix = 0.3
lead.reverb.mix = 0.5

pad: strings.section -> reverb
pad { chords = | C | G7 | G | C | F | G | C | C | }
pad.volume = 0.45

bass: bass.808
bass = | c2 _ _ | g1 _ _ | g1 _ _ | c2 _ _ | f1 _ _ | g1 _ _ | c2 _ _ | c2 _ _ |

drums: drums.808 -> reverb
drums {
  bd = b - -
  hh = - c c
  rim = - - [- k]
}
drums.reverb.mix = 0.25
